import { classNames, scrollPageTo } from '@utils/genUtils'
import React, { MutableRefObject, useEffect, useRef } from 'react'
import { twMerge } from 'tailwind-merge'

interface Props {
  id?: string
  text: string
  offset?: number
  className?: string
}

function CtaButtonTw(props: Props) {
  const { id = 'checkout-card', text, offset = -125, className = '' } = props
  const checkoutContainer: MutableRefObject<null | HTMLElement> = useRef(null)
  const cardContainer: MutableRefObject<null | HTMLElement> = useRef(null)
  useEffect(() => {
    checkoutContainer.current = document.getElementById(id)
  }, [])

  function buttonClick() {
    const width = window.outerWidth
    const mobile = width < 768

    if (!checkoutContainer.current && !mobile) {
      checkoutContainer.current = document.getElementById(id)
      scrollPageTo(checkoutContainer, offset)
      return
    }

    if (!mobile && checkoutContainer.current) {
      scrollPageTo(checkoutContainer, offset)
      return
    }

    if (mobile) {
      cardContainer.current = document.getElementById(id)
      scrollPageTo(cardContainer, -100)
      return
    }

    // scrollPageTo(checkoutContainer, offset)
  }

  return (
    <button className={twMerge(className, 'btn focus:outline-none')} onClick={buttonClick}>{text}</button>
  )
}

export default CtaButtonTw
